<template>
    <div>
    <notifications group="error"  class="notification"/>
    <router-view></router-view>
    </div>
</template>

<script>


export default {
  name: 'App',

 mounted() {
    
    
    this.$store.dispatch("checkLogin");

 
  
  },

  computed: 
  {
    error()
    {
      return this.$store.getters.error;
    },
    success()
    {
      return this.$store.getters.success;
    },
       user()
      {
          return this.$store.getters.auth;
      }
  },
   watch : 
  {
      user(newVal)
      {
        
            if (newVal!=null)
            {
                
               
            }
            else 
            {
                    this.$router.push("/");
            }
         
            
      },
      error(val)
      {
        if (val) this.$notify({
                      group: 'error',
                      title: 'Error',
                      type: 'error',
                      text: val
                    });
      },
      success(val)
      {
        if (val)    this.$notify({
                    group: 'error',
                    title: 'Success',
                    type: 'success',
                    text: val
                  });
      }
 
    
  },

};
</script>
<style lang="scss">
  @import "@/style/components.scss";
  @import "@/style/colors.scss";



.input-field,
.validate,
.valid {
  @extend %input_shared;
}


.btn {
  @extend %primary-button;
}

    .delete_logo 
        {
             @extend %icon-button;
             background:$dangerColor !important;
        }

        .edit_logo 
        {
             @extend %icon-button;
             background:$infoColor !important;
        }

.notification {
  margin-top: 80px;
}

.notification .vue-notification {
  font-size: 16px !important;
  padding: 10px;
  margin-right: 50px;
}

  .sidenav-overlay
        {
          background:none !important;
        }
</style>
